import React, { useEffect, useState } from "react";
import {
  useGetUserDataQuery,
  useSubmitUserDataMutation,
} from "../store/api/userApi";
import { useLocation, useNavigate } from "react-router-dom";
import TextField from "../components/TextField";
import "./pages.css";
import Button from "../components/Button";

export default function PersonalInfoDetailWeb() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [inn, setInn] = useState("");
  const [address, setAdress] = useState("");
  const navigate = useNavigate();
  const [inputErrors, setInputErrors] = useState({});
  const [submitUserData] = useSubmitUserDataMutation();
  const { data: userData } = useGetUserDataQuery();
  const location = useLocation();
  const email = location.state?.email || "";
  const reg = location.state?.reg || "";

  useEffect(() => {
    if (userData && userData.length) {
      setFirstName(userData[0]?.first_name);
      setLastName(userData[0]?.last_name);
      setInn(userData[0]?.ppt_inn);
      setAdress(userData[0]?.address);
    }
  }, [userData]);

  const handleSubmit = async () => {
    const errors = {};
    if (!firstName) errors.firstName = true;
    if (!lastName) errors.lastName = true;
    if (!inn) errors.inn = true;
    if (!address) errors.address = true;

    setInputErrors(errors);
    if (Object.keys(errors).length > 0) return;

    try {
      await submitUserData({
        firstName,
        lastName,
        inn,
        address: address,
        ...(email ? { email } : {}),
      }).unwrap();
      if (reg) {
        navigate("/contact");
        return
      }
      navigate("/orders");
    } catch (err) {
      console.error("Ошибка отправки данных:", err);
    }
  };

  const onlyEnglishLetters = (value) => {
    return value.replace(/[^a-zA-Z]/g, "");
  };

  return (
    <div style={{ height: "100vh", display: "flex", alignItems: "center" }}>
      <div className="personal-info-form">
        <div className="form-title">Добавьте свою информацию</div>
        <p className="form-subtitle">
          Присоединяйтесь к тысячам пользователей, совершающих покупки в
          интернете (ТОЛЬКО ЛАТИНИЦА)
        </p>

        <div className="personal-info_content">
          <TextField
            label="Имя"
            value={firstName}
            onChange={(e) => setFirstName(onlyEnglishLetters(e.target.value))}
            placeholder="Имя"
            error={inputErrors.firstName}
          />

          <TextField
            label="Фамилия"
            value={lastName}
            onChange={(e) => setLastName(onlyEnglishLetters(e.target.value))}
            placeholder="Фамилия"
            error={inputErrors.lastName}
          />

          <TextField
            label="ИНН"
            value={inn}
            onChange={(e) => setInn(e.target.value)}
            placeholder="ИНН"
            error={inputErrors.inn}
          />
          <TextField
            label="Адрес"
            value={address}
            onChange={(e) => setAdress(e.target.value)}
            placeholder="Адрес"
            error={inputErrors.address}
          />
        </div>
        <div className="personal-bottom">
          <Button onClick={handleSubmit}>Сохранить</Button>
        </div>
      </div>
    </div>
  );
}
